// public class ApptProcTotalModel
//     {
//         public int appt_proc_id { get; set; }
//         public string appt_proc_name { get; set; }
//         public string appt_proc_code { get; set; }
//         public int appt_max { get; set; }
//         public int total { get; set; }
//     }

export class ApptProcTotalModel {
    appt_proc_id: number
    appt_proc_name: string
    appt_proc_code: string
    appt_max: number
    total_count: number
    total_duration: number

    constructor(
        appt_proc_id: number,
        appt_proc_name: string,
        appt_proc_code: string,
        appt_max: number,
        total_count: number,
        total_duration: number
    ) {
        this.appt_proc_id = appt_proc_id
        this.appt_proc_name = appt_proc_name
        this.appt_proc_code = appt_proc_code
        this.appt_max = appt_max
        this.total_count = total_count
        this.total_duration = total_duration
    }
}